import type { DutyStatus } from '@/types/validators';

export type ServiceDocumentUploadUnavailableReason = 'booking_not_confirmed' | 'awaiting_service_completion' | 'service_completed' | 'service_cancelled';

export type ServiceDocumentUploadAvailability =
  | {
      canUpload: true;
      reason: null;
      message: null;
    }
  | {
      canUpload: false;
      reason: ServiceDocumentUploadUnavailableReason;
      message: string;
    };

const unavailableMessages: Record<ServiceDocumentUploadUnavailableReason, string> = {
  booking_not_confirmed: 'Dokumente können erst nach einer bestätigten Buchung hochgeladen werden.',
  awaiting_service_completion: 'Dokumente können hochgeladen werden, sobald der Dienst abgeschlossen und die Plattformgebühr bestätigt wurde.',
  service_completed: 'Dieser Dienst ist abgeschlossen. Neue Dokumente können nicht mehr hochgeladen werden.',
  service_cancelled: 'Dieser Dienst wurde storniert. Dokumente können nicht hochgeladen werden.',
};

const getUnavailableReason = (status: DutyStatus): ServiceDocumentUploadUnavailableReason | null => {
  switch (status) {
    case 'performed':
      return null;
    case 'filled':
    case 'pending_contract':
    case 'pending_payment':
      return 'awaiting_service_completion';
    case 'completed':
      return 'service_completed';
    case 'cancelled':
      return 'service_cancelled';
    case 'pending_review':
    case 'open':
      return 'booking_not_confirmed';
  }
};

export const getServiceDocumentUploadAvailability = (status: DutyStatus): ServiceDocumentUploadAvailability => {
  const reason = getUnavailableReason(status);
  if (!reason) {
    return { canUpload: true, reason: null, message: null };
  }

  return {
    canUpload: false,
    reason,
    message: unavailableMessages[reason],
  };
};

export const isServiceDocumentUploadAllowed = (status: DutyStatus): boolean => getServiceDocumentUploadAvailability(status).canUpload;
